import { IS_INDIAN_EXCHANGE, SITE_ROOT } from './constants';

const SIGNAL_TRADING_TUTORIAL_BLOG = '/algo/trading-bot';

const USER_GUIDE_URL = IS_INDIAN_EXCHANGE
  ? 'https://guides.delta.exchange/delta-exchange-india-user-guide'
  : 'https://guides.delta.exchange/delta-exchange-user-guide';

const PRIVACY_POLICY_URL = `${SITE_ROOT}/privacy-policy`;

export { SIGNAL_TRADING_TUTORIAL_BLOG, USER_GUIDE_URL, PRIVACY_POLICY_URL };
